import { render, staticRenderFns } from "./UploadedFileStatus.vue?vue&type=template&id=02889820&scoped=true&"
import script from "./UploadedFileStatus.vue?vue&type=script&lang=js&"
export * from "./UploadedFileStatus.vue?vue&type=script&lang=js&"
import style0 from "./UploadedFileStatus.vue?vue&type=style&index=0&id=02889820&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02889820",
  null
  
)

export default component.exports